import { Injectable } from "@angular/core";
import {
  ICareplan,
  ILink2Careplan,
  IObservationsLoincsInfo,
  IQuestionnaireIdentifierInfo,
  IVitalProfileDefinition,
} from "@comunicare/comunicare-interfaces";
import { ICareplanService } from "@comunicare/comunicare-interfaces-dashboard-services";
import { Observable, of } from "rxjs";
/* tslint:disable:no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* tslint:disable:no-explicit-any */
/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
  providedIn: "root",
})
export class CareplanService implements ICareplanService {
  list(patientId: string, lang?: string): Observable<ICareplan[]> {
    throw new Error("Method not implemented.");
  }
  getCareplanTemplates(serviceRef?: string, lang?: string): Observable<ICareplan[]> {
    throw new Error("Method not implemented.");
  }
  getCareplanTemplateByPublicationDate(careplanRef: string, publicationDate: string, lang?: string): Observable<ICareplan | undefined> {
    throw new Error("Method not implemented.");
  }
  createCareplan(careplan: ICareplan): Observable<ICareplan> {
    throw new Error("Method not implemented.");
  }
  updateCareplan(careplan: ICareplan): Observable<ICareplan> {
    throw new Error("Method not implemented.");
  }
  getLink2Careplan(careplanId: string): Observable<{ published: ILink2Careplan; draft: ILink2Careplan }> {
    throw new Error("Method not implemented.");
  }
  updateLink2Careplan(link2careplan: ILink2Careplan): Observable<ILink2Careplan> {
    throw new Error("Method not implemented.");
  }
  /**
   * The configurator defines no reference value, and the rule editor asks for them as soon as a rule is
   * written on one: an empty list leaves its picker empty rather than breaking the page.
   */
  getAllVitalProfileDefinitions(codes?: string[]): Observable<IVitalProfileDefinition[]> {
    return of([]);
  }
  getCareplanTemplatesWithActivitiesLinkedToQuestionnaire(id: string): Promise<ICareplan[]> {
    throw new Error("Method not implemented.");
  }
  getObservationsLinkedToCareplan(careplanId: string, draft: boolean, publicationDate?: string): Promise<IObservationsLoincsInfo[]> {
    throw new Error("Method not implemented.");
  }
  getQuestionnairesLinkedToCareplan(careplanId: string, draft: boolean, publicationDate?: string): Promise<IQuestionnaireIdentifierInfo[]> {
    throw new Error("Method not implemented.");
  }
}
